<template>
  <div class="Other">

    <div class="wrapper">
      <h1>Other Work</h1>
  
      <h2>I've had the opportunity to leverage and grow my skills across a broad range of mediums and projects; and each one has helped make me a better designer.</h2>
  
      <!-- Projects -->
      <div class="projects">

        <router-link :to="{ name: 'Game' }" class="project">
          <div class="content">
            <img src="/assets/other/game-preview.png" srcset="/assets/other/game-preview.png 303w, /assets/other/game-preview@2x.png 606w" sizes="303px" class="preview">
            <div class="logo">Game Design</div>
            <div class="type">My most recent game.</div>
            <div class="bg"></div>
          </div>
        </router-link>

        <router-link :to="{ name: 'Painting' }" class="project right">
          <div class="content">
            <img src="/assets/other/painting-preview.png" srcset="/assets/other/painting-preview.png 303w, /assets/other/painting-preview@2x.png 606w" sizes="303px" class="preview">
            <div class="logo">Painting</div>
            <div class="type">Select works and exhibits.</div>
            <div class="bg"></div>
          </div>
        </router-link>

        <router-link :to="{ name: 'Architecture' }" class="project">
          <div class="content">
            <img src="/assets/other/architecture-preview.png" srcset="/assets/other/architecture-preview.png 303w, /assets/other/architecture-preview@2x.png 606w" sizes="303px" class="preview">
            <div class="logo arch">Architecture</div>
            <div class="type">Select work.</div>
            <div class="bg"></div>
          </div>
        </router-link>

        <router-link :to="{ name: 'Mediums' }" class="project right">
          <div class="content">
            <img src="/assets/other/other-preview.png" srcset="/assets/other/mediums-preview.png 303w, /assets/other/mediums-preview@2x.png 606w" sizes="303px" class="preview">
            <div class="logo">Other Mediums</div>
            <div class="type">Printmaking &amp; drawing.</div>
            <div class="bg"></div>
          </div>
        </router-link>

      </div>
    </div>

    <Footer />

  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
  name: 'Other',
  components: {
    Footer
  },
}
</script>

<style lang="scss" scoped>
  .Other {
    background: #fff;
    padding: 160px 0 0 0;

    & .wrapper {
      @include siteWrapper;
    }

    & h1 {
      margin: 0 0 60px 0;
      text-align: center;
    }
    & h2 {
      margin: 0 auto 100px auto;
      text-align: center;
      max-width: 1000px;

      @media screen and (max-width: 1000px) {
        padding: 0 40px;
      }
      @media screen and (max-width: $breakSmall) {
        padding: 0 20px;
      }
    }

    & .projects {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      & .project {
        width: 45%;
        padding-bottom: 30%;
        margin: 0 0 10% 0;
        position: relative;
        background: rgb(0,162,203);
        background: radial-gradient(circle at bottom center, rgba(0,162,203,1) 0%, rgba(22,31,109,1) 100%);
        color: #fff;
        transition: all 300ms;

        & .content {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          overflow: hidden;
          z-index: 5;
          opacity: 0;
          animation: loadContent 500ms 700ms forwards;

          @keyframes loadContent {
            from {opacity: 0;}
            to {opacity: 1;}
          }

          & .preview {
            width: 303px;
            width: 48%;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            z-index: 5;
            transition: all 300ms;
          }
          & .logo {
            width: 32%;
            position: absolute;
            right: 11%;
            top: 50%;
            transform: translateY(-50%);
            z-index: 5;
            transition: all 900ms;
            // improve chrome rendering on animation
            will-change: right, left;
            // for passed strings
            @include fontBodyHead;
            font-size: 22px;
            text-transform: uppercase;
            text-align: center;

            @media screen and (max-width: $breakLarge) {
              font-size: 16px;
              line-height: 22px;
            }
            @media screen and (max-width: $breakSmall) {
              font-size: 18px;
              line-height: 26px;
            }
            @media screen and (max-width: $breakHandsetLandscape) {
              font-size: 15px;
              line-height: 20px;
            }
            //arch
            &.arch {
              @media screen and (max-width: 1300px) {
                text-indent: -10%;
              }
              @media screen and (max-width: 950px) {
                font-size: 16px;
              }
              @media screen and (max-width: $breakLarge) {
                font-size: 15px;
              }
              @media screen and (max-width: $breakSmall) {
                font-size: 15px;
              }
              @media screen and (max-width: $breakHandsetLandscape) {
                font-size: 14px;
                text-indent: -15%;
              }
            }
          }
          & .type {
            @include fontBodyHead;
            font-size: 18px;
            line-height: 26px;
            width: 40%;
            text-align: center;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            z-index: 2;
            transition: all 600ms;

          }
          & .bg {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 1;
            background: radial-gradient(circle at center center, rgba(0,162,203,1) 0%, rgba(22,31,109,1) 100%);
            opacity: 0;
            transition: all 300ms;
          }
        }
        &:hover {
          color: #fff;

          & .content {
            & .preview {
              left: -10%;
            }
            & .logo {
              right: -40%;
            }
            & .type {
              left: 48%;
            }
            & .bg {
              opacity: 1;
            }
          }
        }
        // right version
        &.right {

          & .content {

            & .preview {
              left: auto;
              right: 0;
            }
            & .logo {
              right: auto;
              left: 11%;
            }
            & .type {
              left: auto;
              right: 0;
            }
          }
          &:hover {

            & .content {
              & .preview {
                left: auto;
                right: -10%;
              }
              & .logo {
                right: auto;
                left: -40%;
              }
              & .type {
                left: auto;
                right: 48%;
              }
            }
          }
        }
      }

      @media screen and (max-width: $breakSmall) {
        justify-content: space-around;

        & .project {
          width: 100%;
          padding-bottom: 60%;
          margin: 0 0 20% 0;

          &:hover {
            & .content {
              & .preview {
                left: -10%;
              }
              & .logo {
                right: -40%;
              }
              & .type {
                left: 48%;
              }
            }
          }
          &.right {
            &:hover {
              & .content {
                & .preview {
                  right: -10%;
                }
                & .logo {
                  left: -40%;
                }
                & .type {
                  right: 48%;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
